// Candy Bella Hairco — Custom JS
// File: assets/candybella-custom.js

document.addEventListener('DOMContentLoaded', function () {

  // --- Custom Cursor ---
  const cursor = document.createElement('div');
  const ring = document.createElement('div');
  cursor.className = 'cb-cursor';
  ring.className = 'cb-cursor-ring';
  document.body.appendChild(cursor);
  document.body.appendChild(ring);

  document.addEventListener('mousemove', function (e) {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
    ring.style.left = e.clientX + 'px';
    ring.style.top = e.clientY + 'px';
  });

  document.querySelectorAll('a, button').forEach(function (el) {
    el.addEventListener('mouseenter', function () {
      ring.style.transform = 'translate(-50%, -50%) scale(1.6)';
      ring.style.borderColor = 'var(--cb-gold)';
    });
    el.addEventListener('mouseleave', function () {
      ring.style.transform = 'translate(-50%, -50%) scale(1)';
      ring.style.borderColor = 'var(--cb-taupe)';
    });
  });

  // --- Scroll Reveal ---
  var reveals = document.querySelectorAll('.reveal');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function () {
          entry.target.classList.add('visible');
        }, i * 80);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  reveals.forEach(function (el) { observer.observe(el); });

});